import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option, Select, SimpleSelectProps } from 'carbon-react/lib/components/select';

import {
  FIXED_FORECAST_CHOICES,
  ForecastFormElementIds,
  ForecastTypeOption,
  ROLLING_FORECAST_CHOICES
} from '../../types';
export type ForecastDurationProps = Omit<SimpleSelectProps, 'name' | 'id' | 'children' | 'label'> & {
  legend?: string;
  type: ForecastTypeOption | '';
};

const getChoiceLabel = (choice: string, intl: ReturnType<typeof useIntl>) => {
  if (choice.includes('FY+')) {
    const value = choice.replace('FY+', '');
    return intl.formatMessage(
      {
        id: 'predict.create_forecast.forecast_duration_choice_fy+x_year',
        defaultMessage: 'This FY + {value} year'
      },
      {
        value
      }
    );
  } else {
    return intl.formatMessage(
      {
        id: 'predict.create_forecast.forecast_duration_choice_year',
        defaultMessage: '{value} year'
      },
      {
        value: choice
      }
    );
  }
};

export const ForecastDuration = ({ legend, type, ...props }: ForecastDurationProps) => {
  const intl = useIntl();
  const choices = (() => {
    if (type === ForecastTypeOption.Fixed) {
      return FIXED_FORECAST_CHOICES;
    } else if (type === ForecastTypeOption.Rolling) {
      return ROLLING_FORECAST_CHOICES;
    } else {
      return [];
    }
  })();

  return (
    <Box>
      <Select
        name={ForecastFormElementIds.Duration}
        id={ForecastFormElementIds.Duration}
        label={legend}
        inputHint={
          type === ForecastTypeOption.Rolling
            ? intl.formatMessage({
                id: 'predict.create_forecast.how_far_ahead_should_this_forecast_look',
                defaultMessage: 'How far ahead should this forecast look?'
              })
            : undefined
        }
        required
        listMaxHeight={240}
        {...props}
      >
        {choices.map(choice => (
          <Option key={choice} value={choice} text={getChoiceLabel(choice, intl)} />
        ))}
      </Select>
    </Box>
  );
};
